import { createContext } from 'react';

const LoggedInUserContext = createContext();

LoggedInUserContext.displayName = 'LoggedInUserContext';

export default LoggedInUserContext;
